// ─── MODAL: EDITAR CLIENTE (atualiza base original) ───────────
import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import ContatosVinculadosBox, { ContatosVinculadosHandle } from '../../components/ContatosVinculadosBox';
import { API_URL } from '../../config';
import { getToken } from '../../utils/auth';
import { inp, modalOverlayLocal, modalContentLocal, btnSecLocal, btnPriLocal } from './utils';

export function ModalEditarCliente({ clienteId, onClose, onSaved }: {
  clienteId: number;
  onClose: () => void;
  onSaved: () => void;
}) {
  const [form, setForm] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [salvando, setSalvando] = useState(false);
  const contatosRef = useRef<ContatosVinculadosHandle>(null);

  useEffect(() => {
    (async () => {
      try {
        const token = await getToken();
        // Não há GET /comercial/clientes/{id}, então busca lista e filtra
        const res = await axios.get(`${API_URL}/comercial/clientes`, { headers: { Authorization: token } });
        const data = res.data.body ? JSON.parse(res.data.body) : res.data;
        const c = (Array.isArray(data) ? data : []).find((x: any) => x.id === clienteId);
        if (c) setForm({ ...c });
      } finally { setLoading(false); }
    })();
  }, [clienteId]);

  async function salvar() {
    if (!form?.razao_social?.trim()) { alert('Razão social obrigatória'); return; }
    setSalvando(true);
    try {
      const token = await getToken();
      await axios.put(`${API_URL}/comercial/clientes/${clienteId}`, form,
        { headers: { Authorization: token } });
      // Sincroniza contatos vinculados (cria/associa/desassocia conforme delta)
      if (contatosRef.current) {
        await contatosRef.current.commit(clienteId);
      }
      onSaved();
    } catch (e: any) {
      alert('Erro: ' + (e.response?.data?.error || e.response?.data?.erro || e.message));
    } finally { setSalvando(false); }
  }

  if (loading || !form) return null;
  const lbl: React.CSSProperties = { fontSize: 11, fontWeight: 600, color: '#555', display: 'block', marginBottom: 3 };
  return (
    <div style={modalOverlayLocal} onClick={onClose}>
      <div style={{ ...modalContentLocal, maxWidth: 580 }} onClick={e => e.stopPropagation()}>
        <h3 style={{ margin: '0 0 14px', fontSize: 15, color: '#020D7F' }}>Editar empresa</h3>
        <div style={{ display: 'grid', gap: 10 }}>
          <div>
            <label style={lbl}>Razão social *</label>
            <input value={form.razao_social || ''}
              onChange={e => setForm({ ...form, razao_social: e.target.value })} style={inp} />
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
            <div>
              <label style={lbl}>CNPJ</label>
              <input value={form.cnpj || ''} onChange={e => setForm({ ...form, cnpj: e.target.value })} style={inp} />
            </div>
            <div>
              <label style={lbl}>Porte</label>
              <input value={form.porte || ''} onChange={e => setForm({ ...form, porte: e.target.value })} style={inp} />
            </div>
          </div>
          <div>
            <label style={lbl}>Segmento</label>
            <input value={form.segmento || ''} onChange={e => setForm({ ...form, segmento: e.target.value })} style={inp} />
          </div>
          <div>
            <label style={lbl}>Endereço</label>
            <input value={form.endereco || ''} onChange={e => setForm({ ...form, endereco: e.target.value })} style={inp} />
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr', gap: 8 }}>
            <div>
              <label style={lbl}>Cidade</label>
              <input value={form.cidade || ''} onChange={e => setForm({ ...form, cidade: e.target.value })} style={inp} />
            </div>
            <div>
              <label style={lbl}>UF</label>
              <input value={form.uf || ''} maxLength={2}
                onChange={e => setForm({ ...form, uf: e.target.value.toUpperCase() })} style={inp} />
            </div>
            <div>
              <label style={lbl}>CEP</label>
              <input value={form.cep || ''} onChange={e => setForm({ ...form, cep: e.target.value })} style={inp} />
            </div>
          </div>
          <div>
            <label style={lbl}>Observações</label>
            <textarea value={form.observacoes || ''}
              onChange={e => setForm({ ...form, observacoes: e.target.value })}
              style={{ ...inp, minHeight: 60, resize: 'vertical' }} />
          </div>
          {/* Contatos vinculados (many-to-many) */}
          <ContatosVinculadosBox ref={contatosRef} clienteId={clienteId} />
        </div>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 14 }}>
          <button onClick={onClose} style={btnSecLocal}>Cancelar</button>
          <button onClick={salvar} disabled={salvando} style={btnPriLocal}>
            {salvando ? 'Salvando...' : 'Salvar empresa'}
          </button>
        </div>
      </div>
    </div>
  );
}
